import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import SexMachinesPage from './pages/SexMachinesPage'
import RoboticsPage from './pages/RoboticsPage'
import UnlimitedPage from './pages/UnlimitedPage'
import ShopPage from './pages/ShopPage'
import NewsPage from './pages/NewsPage'
import ContactPage from './pages/ContactPage'
import CartPage from './pages/CartPage'
import AdminPage from './pages/AdminPage'
import AboutPage from './pages/AboutPage'
import TankSuccessPage from './pages/TankSuccessPage'
import ServicesPage from './pages/ServicesPage'
import TutorialsPage from './pages/TutorialsPage'
import ReferencesPage from './pages/ReferencesPage'
import ResearchPage from './pages/ResearchPage'
import PrototypesPage from './pages/PrototypesPage'
import ExperimentalPage from './pages/ExperimentalPage'
import NeserioveVyrobkyPage from './pages/NeserioveVyrobkyPage'
import FilesPage from './pages/FilesPage'
import OperativniLeasingPage from './pages/OperativniLeasingPage'
import AdminSessionKeeper from './components/AdminSessionKeeper'
import { CartProvider } from './context/CartContext'

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  try {
    return (
      <CartProvider>
        <Router>
          <ScrollToTop />
          <AdminSessionKeeper />
          <div className="font-sans">
            <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/sex-machines" element={<Layout><SexMachinesPage /></Layout>} />
            <Route path="/robotics" element={<Layout><RoboticsPage /></Layout>} />
            <Route path="/unlimited" element={<Layout><UnlimitedPage /></Layout>} />
            <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/shop" element={<Layout><ShopPage /></Layout>} />
            <Route path="/news" element={<Layout><NewsPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/cart" element={<Layout><CartPage /></Layout>} />
            <Route path="/admin" element={<Layout><AdminPage /></Layout>} />
            <Route path="/about" element={<Layout><AboutPage /></Layout>} />
            <Route path="/navody" element={<Layout><TutorialsPage /></Layout>} />
            <Route path="/reference" element={<Layout><ReferencesPage /></Layout>} />
            <Route path="/vyzkum" element={<Layout><ResearchPage /></Layout>} />
            <Route path="/prototypy" element={<Layout><PrototypesPage /></Layout>} />
            <Route path="/experimentalni" element={<Layout><ExperimentalPage /></Layout>} />
            <Route path="/neseriove-vyrobky" element={<Layout><NeserioveVyrobkyPage /></Layout>} />
            <Route path="/soubory" element={<Layout><FilesPage /></Layout>} />
            <Route path="/operativni-leasing" element={<Layout><OperativniLeasingPage /></Layout>} />
            <Route path="/tank-success" element={<TankSuccessPage />} />
          </Routes>
        </div>
      </Router>
      </CartProvider>
    )
  } catch (error) {
    console.error('App rendering error:', error);
    return (
      <div className="min-h-screen bg-black flex items-center justify-center text-white">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-red-500 mb-4">Cybertronic</h1>
          <p>Aplikace se načítá...</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-500"
          >
            Obnovit stránku
          </button>
        </div>
      </div>
    );
  }
}

export default App